import axios from 'axios'
import {ResponseObject} from '../../../models'
import {
  OccupancyReportDTO,
  OccupancyTableReportDTO,
  Occupancy2ReportDTO,
  OccupancySubReportDTO,
  OccupancyFilterSubReportDTO,
  OccupancyPerDayFilterReportDTO,
  DayliReportDTO,
  ValuationHeaderReportDTO,
} from '../models/reports.model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getOccupancyReportList(dto: OccupancyReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(`${BASEURL}/occupancyReport/getList`, dto)
  return resp.data
}

export async function getOccupancyTableReportList(dto: OccupancyTableReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(`${BASEURL}/occupancyReport/getListStays`, dto)
  return resp.data
}

export async function getDailyOccupancyReportList(dto: OccupancyReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getDailyReport`,
    dto,
  )
  return resp.data
}

export async function getDailyGuestOccupancyList(dto: OccupancyFilterSubReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListGuestDaysStays`,
    dto,
  )
  return resp.data
}
// ---------------------------------------------------------------------------------------------------------------

export async function getOccupancyTableList(dto: OccupancySubReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListReportGrafic`,
    dto,
  )
  return resp.data
}

export async function getOccupancy2TableList(dto: Occupancy2ReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getReportOccupation`,
    dto,
  )
  return resp.data
}

// ------------------------------FILTER ---------------------------------------------------------------------------------
export async function getFilterGuestOccupancyTableList(dto: OccupancyFilterSubReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(`${BASEURL}/occupancyReport/getListGuest`, dto)
  return resp.data
}

export async function getFilterEnterpriseOccupancyTableList(dto: OccupancyFilterSubReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListEnterprise`,
    dto,
  )
  return resp.data
}

export async function getFilterModuleOccupancyTableList(dto: OccupancyFilterSubReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListModule`,
    dto,
  )
  return resp.data
}

export async function getFilterRoomOccupancyTableList(dto: OccupancyFilterSubReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(`${BASEURL}/occupancyReport/getListRoom`, dto)
  return resp.data
}

export async function getFilterBedOccupancyTableList(dto: OccupancyFilterSubReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(`${BASEURL}/occupancyReport/getListBed`, dto)
  return resp.data
}

// ------------------------------REPORT-3 - FILTER ---------------------------------------------------------------------------------
export async function getFilterGuestOccupancyReportDTableList(dto: OccupancyPerDayFilterReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListGuestPerDay`,
    dto,
  )
  return resp.data
}

export async function getFilterEnterpriseOccupancyReportDTableList(
  dto: OccupancyPerDayFilterReportDTO,
) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListEnterprisePerDay`,
    dto,
  )
  return resp.data
}

export async function getFilterModuleOccupancyReportDTableList(
  dto: OccupancyPerDayFilterReportDTO,
) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListModulePerDay`,
    dto,
  )
  return resp.data
}

export async function getFilterRoomOccupancyReportDTableList(dto: OccupancyPerDayFilterReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListRoomPerDay`,
    dto,
  )
  return resp.data
}

export async function getFilterBedOccupancyReportDTableList(dto: OccupancyPerDayFilterReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListBedPerDay`,
    dto,
  )
  return resp.data
}

export async function getReportDayliTableList(dto: DayliReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(
    `${BASEURL}/occupancyReport/getListReportDay`,
    dto,
  )
  return resp.data
}

// -------------------------------- VALORACION ----------------------------
export async function getReportValuationList(dto: ValuationHeaderReportDTO) {
  const resp = await axios.post<ResponseObject<any>>(`${BASEURL}/valuationReport/getList`, dto)
  return resp.data
}

export function getReportValuationExcel(dto: any) {
  return axios.post<any>(`${BASEURL}/valuationReport/getExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}
